
define('template!pimSearchTpl', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="content pim-search">\n  <div class="well">\n    <h2 style="margin-bottom: 12px;">' +
((__t = ( _.i18n('common.productFinder') )) == null ? '' : __t) +
'</h2>\n\n    <div class="search-bar">\n      <input type="text" class="form-control js-search-input search-input" placeholder="Search products by name" />\n      <button class="btn btn-primary js-search-btn search-btn">\n        <i class="fa fa-search"></i> <span>Search</span>\n      </button>\n    </div>\n\n    <div class="js-loader loader-3" style="display: none;"></div>\n\n    <div class="js-error alert alert-danger" style="display: none;"></div>\n\n    ';
 if (hasResults) { ;
__p += '\n      <div class="results-grid js-results">\n        ';
 _.each(results, function(item){ ;
__p += '\n          <div class="grid-item">\n            <div class="result-card js-result-card" data-product-id="' +
((__t = ( item.id )) == null ? '' : __t) +
'" title="">\n              <div class="result-thumb">\n                <img src="' +
((__t = ( item.img )) == null ? '' : __t) +
'" alt="preview" loading="lazy" decoding="async" sizes="(min-width: 1200px) 260px, (min-width: 768px) 33vw, 50vw" />\n                ';
 if (item.deprecated) { ;
__p += '\n                  <span class="deprecated-badge" title="' +
((__t = ( _.i18n('productList.outDated') )) == null ? '' : __t) +
'" aria-label="' +
((__t = ( _.i18n('productList.outDated') )) == null ? '' : __t) +
'">\n                    <i class="mdi-action-info-outline" aria-hidden="true" style="color: red;"></i>\n                    <span class="sr-only">' +
((__t = ( _.i18n('productList.outDated') )) == null ? '' : __t) +
'</span>\n                  </span>\n                ';
 } ;
__p += '\n              </div>\n              <div class="meta">\n                <div><span class="label">Product name:</span> <span class="value">' +
((__t = ( item.productName || '' )) == null ? '' : __t) +
'</span></div>\n                <div><span class="label">Product code:</span> <span class="value">' +
((__t = ( item.productCode )) == null ? '' : __t) +
'</span></div>\n                <div><span class="label">Supplier product code:</span> <span class="value">' +
((__t = ( item.supplierProductCode )) == null ? '' : __t) +
'</span></div>\n                <div><span class="label">Supplier:</span> <span class="value">' +
((__t = ( item.supplierName )) == null ? '' : __t) +
'</span></div>\n                ';
 if (item.stockQty != null) { ;
__p += '\n                  <div class="stock-line">\n                    <span class="label">Stock:</span>\n                    <span class="value">\n                      ';
 if (item.stockQty > 0) { ;
__p += '\n                        <span class="stock-indicator" title="In stock" aria-label="In stock">In stock</span>\n                      ';
 } else { ;
__p += '\n                        <span>—</span>\n                      ';
 } ;
__p += '\n                    </span>\n                  </div>\n                ';
 } ;
__p += '\n                ';
 if (item.nbrOffer != null || item.nbrOrder != null) { ;
__p += '\n                  <div class="stats-line" title="Offers, orders and conversion rate">\n                    ';
 var no = (item.nbrOffer != null ? item.nbrOffer : '—'); ;
__p += '\n                    ';
 var nr = (item.nbrOrder != null ? item.nbrOrder : '—'); ;
__p += '\n                    ';
 var cr = (item.conversionRate != null ? (Math.round(item.conversionRate * 10) / 10) + '%' : '—'); ;
__p += '\n                    <span class="label">Offers:</span> <span class="value">' +
((__t = ( no )) == null ? '' : __t) +
'</span>\n                    <span class="sep">•</span>\n                    <span class="label">Orders:</span> <span class="value">' +
((__t = ( nr )) == null ? '' : __t) +
'</span>\n                    <span class="sep">•</span>\n                    <span class="label">Conv:</span> <span class="value">' +
((__t = ( cr )) == null ? '' : __t) +
'</span>\n                  </div>\n                ';
 } ;
__p += '\n                ';
 if (item.colors && item.colors.length) { ;
__p += '\n                  <div class="color-dots" title="Available colors">\n                    ';
 var maxDots = 8; var extra = Math.max(0, item.colors.length - maxDots); ;
__p += '\n                    ';
 for (var i = 0; i < Math.min(item.colors.length, maxDots); i++) { var c = item.colors[i]; ;
__p += '\n                      ';
 if (c.value) { ;
__p += '\n                        <span class="dot" title="' +
((__t = ( c.label || '' )) == null ? '' : __t) +
'">\n                          <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">\n                            <circle cx="7" cy="7" r="7" fill="' +
((__t = ( c.value )) == null ? '' : __t) +
'" stroke="rgba(0,0,0,0.12)" />\n                          </svg>\n                        </span>\n                      ';
 } else { ;
__p += '\n                        <span class="dot is-empty" title="' +
((__t = ( c.label || '' )) == null ? '' : __t) +
'"></span>\n                      ';
 } ;
__p += '\n                    ';
 } ;
__p += '\n                    ';
 if (extra > 0) { ;
__p += '\n                      <span class="dot more" title="+' +
((__t = ( extra )) == null ? '' : __t) +
' more">+' +
((__t = ( extra )) == null ? '' : __t) +
'</span>\n                    ';
 } ;
__p += '\n                  </div>\n                ';
 } ;
__p += '\n              </div>\n              <div class="card-actions js-card-actions">\n                <button class="btn btn-default btn-xs js-info-btn" title="Show info" aria-label="Show info about this product">\n                  <i class="fa fa-info-circle" aria-hidden="true"></i>\n                  <span class="sr-only">Info</span>\n                </button>\n                <a class="btn btn-primary btn-xs js-open-link" href="#pim/products/' +
((__t = ( item.id )) == null ? '' : __t) +
'" title="Open details" aria-label="Open product details">\n                  <i class="fa fa-external-link" aria-hidden="true"></i>\n                  <span class="sr-only">Open</span>\n                </a>\n              </div>\n            </div>\n          </div>\n        ';
 }); ;
__p += '\n        ';
 if (loadingMore) { ;
__p += '\n          <div class="grid-item loader-item" aria-hidden="true">\n            <div class="loader-3" title="Loading more"></div>\n          </div>\n        ';
 } ;
__p += '\n      </div>\n    ';
 } else if (!loading) { ;
__p += '\n      <div class="js-empty muted">No results</div>\n    ';
 } ;
__p += '\n  </div>\n</div>\n';

}
return __p
};});

